import { supabase } from '../../services/supabaseClient'; // Adjust this path
import { useUser } from './UserContext'; // Import useUser
import { useAuth } from './AuthContext'; // Import useAuth
import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';



export default function Login() {
  const navigate = useNavigate();
  const { setUser } = useUser(); // Get setUser function from UserContext
  const { loading: loadingAuth } = useAuth(); // Get loading state from AuthContext
  const [errorMessage, setErrorMessage] = useState(''); // Handle error messages

  // Check if the user is already authenticated
  useEffect(() => {
    const checkUser = async () => {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (session) {
        navigate('/signup'); // Redirect to dashboard if user is already logged in
      }
    };

    checkUser();
  }, [navigate]);

  // Form state
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Handle email & password login
  const handleEmailSignIn = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setErrorMessage(''); // Clear previous error messages

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        setErrorMessage(error.message);
        console.error('Email Sign In Error:', error.message);
      } else if (data.user) {
        setUser(data.user);
        navigate('/signup'); // Redirect to the dashboard or another protected route
      }
    } catch (err) {
      navigate('/signup');
      setErrorMessage('Unexpected error occurred. Please try again.');
      console.error('Unexpected Error:', err.message);
    }
  };



  if (loadingAuth) {
    return <div>Loading...</div>; // Show loading indicator while checking auth state
  }


  return (
    
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          className="mx-auto h-10 w-auto"
          src="https://tailwindui.com/plus/img/logos/mark.svg?color=indigo&shade=600"
          alt="Your Company"
        />
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Sign in to your account
        </h2>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        {/* Show error message if there is one */}
        {errorMessage && <div className="mb-4 text-red-500 text-center">{errorMessage}</div>}
        
        <form className="space-y-6" onSubmit={handleEmailSignIn}>
          <div>
            <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
              Email address
            </label>
            <div className="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                Password
              </label>
              {/* <div className="text-sm">
                <Link to="#" className="font-semibold text-indigo-600 hover:text-indigo-500">
                  Forgot password?
                </Link>
              </div> */}
            </div>
            <div className="mt-2">
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Sign in
            </button>
          </div>
        </form>


        {/* <p className="mt-10 text-center text-sm text-gray-500">
          Not a member?&nbsp;
          <Link to="#" className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500">
            Start a 14 day free trial
          </Link>
        </p> */}
      </div>
    </div>
  );
}
